// extracted by mini-css-extract-plugin
export default {"container":"Console_container__+8PbF","message":"Console_message__9Uvh+"};